export const projectsProjectDetailHostCapability = 'projects.detail-host.v1';
export const projectsProjectDetailHostSlots = {
    summary: 'projects.detail.summary',
    actions: 'projects.detail.actions',
    tabs: 'projects.detail.tabs',
    sidebar: 'projects.detail.sidebar',
    timeline: 'projects.timeline.providers',
};
//# sourceMappingURL=projects-project-detail-host.contract.js.map